export class Message {
    name: string;
    text: string;
    number?: number;
    email?: string;
    readed: boolean;
}
